import { RequestsAndLicensesTab } from '@/enums/tabs';
import { BreadCrumbModel } from '@/models/breadcrumb';
import i18n from '@/plugins/i18n';
import { RequestsTypesLinks } from '@/services/staticLookups';

const Breadcrumbs = {
  requestsList: [
    {
      text: i18n.t('judicialLicenses'),
      href: '/',
    },
    {
      text: i18n.t('marriageOfficials'),
      href: '/',
    },
  ],
  newRequest: [{
    text: i18n.t('requestNewAuthorizedLicense'),
    href: RequestsTypesLinks.new,
  }] as BreadCrumbModel[],

  marriageOfficialGuide: [{
    text: i18n.t('marriageOfficialGuide'),
    href: '/guide',
  }] as BreadCrumbModel[],

  licenseDetails: [{
    text: i18n.t('judicialLicenses'),
    href: '/',
  },
  {
    text: i18n.t('marriageOfficials'),
    href: '/',
  },
  {
    text: i18n.t('licenseAndDetails.licenseDetails'),
    href: '/license-details',
  }] as BreadCrumbModel[],

  requestViewMode: [{
    text: i18n.t('requestReview'),
    href: '/',
  }] as BreadCrumbModel[],

  renewRequest: [{
    text: i18n.t('renewRequest'),
    href: RequestsTypesLinks.renew,
  }] as BreadCrumbModel[],

  reregisterRequest: [{
    text: i18n.t('reregisterRequest'),
    href: RequestsTypesLinks.reregister,
  }] as BreadCrumbModel[],

  reissueRequest: [{
    text: i18n.t('reissueLicenseRequest'),
    href: RequestsTypesLinks.reissueLink,
  }] as BreadCrumbModel[],

  cancelRequest: [{
    text: i18n.t('judicialLicenses'),
    href: '/',
  },
  {
    text: i18n.t('marriageOfficials'),
    href: '/',
  },
  {
    text: i18n.t('cancelLicenseRequest'),
    href: RequestsTypesLinks.cancel,
  }] as BreadCrumbModel[],

  viewRequest: [{
    text: i18n.t('judicialLicenses'),
    href: '/',
  },
  {
    text: i18n.t('marriageOfficials'),
    href: '/',
  },
  {
    text: i18n.t('requests'),
    href: `/requests&licenses#${RequestsAndLicensesTab.requests}`,
  },
  {
    text: i18n.t('viewRequestDetails'),
    href: RequestsTypesLinks.viewRequest,
  }] as BreadCrumbModel[],

  updateLicenseRequest: [
    {
      text: i18n.t('judicialLicenses'),
      href: '/',
    },
    {
      text: i18n.t('marriageOfficials'),
      href: '/',
    },
    {
      text: i18n.t('updateLicenseRequest'),
      href: RequestsTypesLinks.updateLicense,
    }] as BreadCrumbModel[],

  updateNameRequest: [
    {
      text: i18n.t('judicialLicenses'),
      href: '/',
    },
    {
      text: i18n.t('marriageOfficials'),
      href: '/',
    },
    {
      text: i18n.t('updateNameRequest'),
      href: RequestsTypesLinks.updateName,
    }] as BreadCrumbModel[],

  updateActions: [{
    text: i18n.t('updateMarriageOfficialData'),
    href: '/update',
  }] as BreadCrumbModel[],
};

export default Breadcrumbs;
